import {
  Typography,
  TypographyProps,
} from "@faire/web--source/slate/Typography";
import React from "react";

interface IProps extends Omit<TypographyProps, "as"> {
  children: React.ReactNode;
}

export const SEOOptimizedHeading: React.FC<IProps> = ({
  children,
  ...typographyProps
}) => {
  return (
    <Typography as="h1" variant="displaySSerifRegular" {...typographyProps}>
      {children}
    </Typography>
  );
};
